import {
  AmFootballCoupon,
  AmFootballDoubleWheel,
  AmFootballQuiz,
  AmFootballTotalTDs,
  BaseballCoupon,
  BaseballDoubleWheel,
  BaseballQuiz,
  BaseballTotalRuns,
  BasketballCoupon,
  BasketballDoubleWheel,
  BasketballQuiz,
  BasketballTotalPoints,
  FootballCoupon,
  FootballDoubleWheel,
  FootballPick6,
  FootballQuiz,
  FootballTotalGoals,
  IceHockeyCoupon,
  IceHockeyDoubleWheel,
  IceHockeyPick6,
  IceHockeyQuiz,
  IceHockeyTotalGoals,
  MMACoupon,
  MMAQuiz,
  MMATotalRounds,
  TennisCoupon,
  TennisDoubleWheel,
  TennisQuiz,
  TennisTotalGoals,
  // CasinoDoubleWheel,
  CasinoClassicWheel,
  CasinoPrizeDrop,
  CasinoProgressiveBoardGame,
  CasinoReels,
  CasinoScratchCard,
  CasinoTrippleWheel,
  Jackpot1,
  Jackpot2,
  Jackpot3,
} from '@/assets';
import { Game } from '@/types/Game';

export const games: Game[] = [
  // --- Sports ---
  {
    id: 'amfootball-coupon',
    category: 'sports',
    subcategory: 'american football',
    name: 'Coupon',
    img: AmFootballCoupon,
  },
  {
    id: 'amfootball-doublewheel',
    category: 'sports',
    subcategory: 'american football',
    name: 'Double Wheel',
    img: AmFootballDoubleWheel,
  },
  { id: 'amfootball-quiz', category: 'sports', subcategory: 'american football', name: 'Quiz', img: AmFootballQuiz },
  {
    id: 'amfootball-totaltds',
    category: 'sports',
    subcategory: 'american football',
    name: 'Total TDs',
    img: AmFootballTotalTDs,
  },

  { id: 'baseball-coupon', category: 'sports', subcategory: 'baseball', name: 'Coupon', img: BaseballCoupon },
  {
    id: 'baseball-doublewheel',
    category: 'sports',
    subcategory: 'baseball',
    name: 'Double Wheel',
    img: BaseballDoubleWheel,
  },
  { id: 'baseball-quiz', category: 'sports', subcategory: 'baseball', name: 'Quiz', img: BaseballQuiz },
  {
    id: 'baseball-totalruns',
    category: 'sports',
    subcategory: 'baseball',
    name: 'Total Runs',
    img: BaseballTotalRuns,
  },

  { id: 'basketball-coupon', category: 'sports', subcategory: 'basketball', name: 'Coupon', img: BasketballCoupon },
  {
    id: 'basketball-doublewheel',
    category: 'sports',
    subcategory: 'basketball',
    name: 'Double Wheel',
    img: BasketballDoubleWheel,
  },
  { id: 'basketball-quiz', category: 'sports', subcategory: 'basketball', name: 'Quiz', img: BasketballQuiz },
  {
    id: 'basketball-totalpoints',
    category: 'sports',
    subcategory: 'basketball',
    name: 'Total Points',
    img: BasketballTotalPoints,
  },

  { id: 'football-coupon', category: 'sports', subcategory: 'football', name: 'Coupon', img: FootballCoupon },
  {
    id: 'football-doublewheel',
    category: 'sports',
    subcategory: 'football',
    name: 'Double Wheel',
    img: FootballDoubleWheel,
  },
  { id: 'football-pick6', category: 'sports', subcategory: 'football', name: 'Pick6', img: FootballPick6 },
  { id: 'football-quiz', category: 'sports', subcategory: 'football', name: 'Quiz', img: FootballQuiz },
  {
    id: 'football-totalgoals',
    category: 'sports',
    subcategory: 'football',
    name: 'Total Goals',
    img: FootballTotalGoals,
  },

  { id: 'icehockey-coupon', category: 'sports', subcategory: 'ice hockey', name: 'Coupon', img: IceHockeyCoupon },
  {
    id: 'icehockey-doublewheel',
    category: 'sports',
    subcategory: 'ice hockey',
    name: 'Double Wheel',
    img: IceHockeyDoubleWheel,
  },
  { id: 'icehockey-pick6', category: 'sports', subcategory: 'ice hockey', name: 'Pick6', img: IceHockeyPick6 },
  { id: 'icehockey-quiz', category: 'sports', subcategory: 'ice hockey', name: 'Quiz', img: IceHockeyQuiz },
  {
    id: 'icehockey-totalgoals',
    category: 'sports',
    subcategory: 'ice hockey',
    name: 'Total Goals',
    img: IceHockeyTotalGoals,
  },

  { id: 'mma-coupon', category: 'sports', subcategory: 'mma', name: 'Coupon', img: MMACoupon },
  { id: 'mma-quiz', category: 'sports', subcategory: 'mma', name: 'Quiz', img: MMAQuiz },
  { id: 'mma-totalrounds', category: 'sports', subcategory: 'mma', name: 'Total Rounds', img: MMATotalRounds },

  { id: 'tennis-coupon', category: 'sports', subcategory: 'tennis', name: 'Coupon', img: TennisCoupon },
  {
    id: 'tennis-doublewheel',
    category: 'sports',
    subcategory: 'tennis',
    name: 'Double Wheel',
    img: TennisDoubleWheel,
  },
  { id: 'tennis-quiz', category: 'sports', subcategory: 'tennis', name: 'Quiz', img: TennisQuiz },
  { id: 'tennis-totalgoals', category: 'sports', subcategory: 'tennis', name: 'Total Goals', img: TennisTotalGoals },

  // --- Casino ---
  { id: 'casino-classicwheel', category: 'casino', name: 'Classic Wheel', img: CasinoClassicWheel },
  // TODO: double wheel image to be added, right not image is the same
  // { id: 'casino-doublewheel', category: 'casino', name: 'Double Wheel', img: CasinoDoubleWheel },
  { id: 'casino-prizedrop', category: 'casino', name: 'Prize Drop', img: CasinoPrizeDrop },
  {
    id: 'casino-progressiveboardgame',
    category: 'casino',
    name: 'Progressive Board Game',
    img: CasinoProgressiveBoardGame,
  },
  { id: 'casino-reels', category: 'casino', name: 'Reels', img: CasinoReels },
  { id: 'casino-scratchcard', category: 'casino', name: 'Scratch Card', img: CasinoScratchCard },
  { id: 'casino-tripplewheel', category: 'casino', name: 'Tripple Wheel', img: CasinoTrippleWheel },

  // --- Jackpots ---
  { id: 'jackpot-1', category: 'jackpots', name: 'Jackpot 1', img: Jackpot1 },
  { id: 'jackpot-2', category: 'jackpots', name: 'Jackpot 2', img: Jackpot2 },
  { id: 'jackpot-3', category: 'jackpots', name: 'Jackpot 3', img: Jackpot3 },
];
